export default __webpack_public_path__ + "static/media/Rel-Poster Dr. Bansal Mumbai.beabfbfd.pdf";